// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { Pie, PieChart, Sector } from "recharts";
import { bindActionCreators, Dispatch } from "redux";
import {
  AbrNum,
  alertActions,
  alertListActions,
  convertUTCToFormattedText
} from "src/actions";

import {
  GeoMap,
  MultiMediaActive,
  Timer,
} from "src/controllers/alerts/components";

import { DuoButtons, ToggleButtons } from "src/components";

import { alertsClasses as myClasses } from "../../";

import { Alert, HTMLDivProps, Text } from "@blueprintjs/core";
import {
  Classes,
  MPDButton,
  MPDHiddenScrollContainer,
  MPDIcon,
  States
} from "src/mpd-library/";

import "./styles.css";

interface IDescriptionProps extends HTMLDivProps {
  composeActive?: boolean;
  listItem?: any;
  multiMedia: any;
  updateAlertState: string;
  warningContent: any;
  routeProps?: any;
  isMobileSize?: boolean;
  rightPanelExpanded?: boolean;
  loading?: boolean;
  onToggleUpdateAlert: (
    type: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onMultiMediaStateChange: (
    type: string,
    fileTypes: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onUploadMultiMedia: (
    files: any,
    type: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  removeFile: (name: string) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel: (
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onToggleRightPanel: () => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar(topBarProps: any): void;
}

interface IDescriptionState {
  imagesLoading?: boolean;
  showMap?: boolean;
}

class Description extends React.Component<
  IDescriptionProps,
  IDescriptionState
> {
  constructor(props: IDescriptionProps) {
    super(props);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onMultiMediaDrop = this.onMultiMediaDrop.bind(this);
    this.onMultiMediaStateChange = this.onMultiMediaStateChange.bind(this);
    this.onToggleRightPanel = this.onToggleRightPanel.bind(this);
    this.onUpdateClick = this.onUpdateClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onCloseRightPanel = this.onCloseRightPanel.bind(this);
    this.updateToolBar(this.props.listItem.listData.title);
    this.state = {
      imagesLoading: true,
      showMap: false
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({showMap: true});
    }, 300);
  }

  public componentWillReceiveProps(nextProps: IDescriptionProps) {
    if (
      this.props.listItem.listData.imageSrc !==
      nextProps.listItem.listData.imageSrc
    ) {
      this.setState({ imagesLoading: true });
    }
    if(nextProps.listItem.listData.title !== this.props.listItem.listData.title){
      this.updateToolBar(nextProps.listItem.listData.title);
    }
  }

  public render() {
    const {
      listItem,
      className,
      updateAlertState,
      warningContent,
      // isMobileSize,
      multiMedia
    } = this.props;

    const { imagesLoading, showMap } = this.state;

    const { listData } = listItem;
    const {
      date,
      title,
      analytics,
      type,
      description,
      instructions,
      details,
      mapCenter,
      currentShape,
      imageSrc
    } = listData;
    const { reach, views, replies } = analytics;
    const {
      sentOn,
      expires,
      severity,
      urgency,
      certainty,
      sentBy,
      area,
      agency,
      alertType,
      status,
      anotherItem,
      bigItem
    } = details;
    const dataReach = [
      { name: AbrNum(reach, 1), value: parseInt(reach, 10) },
      { name: "Total", value: 4000 }
    ];
    const dataViews = [
      { name: AbrNum(views, 1), value: parseInt(views, 10) },
      { name: "Reach", value: parseInt(reach, 10) }
    ];
    const dataReplies = [
      { name: AbrNum(replies, 1), value: parseInt(replies, 10) },
      { name: "Views", value: parseInt(views, 10) }
    ];

    const classes = classNames(myClasses.ALERTS_CONTENT_CONTAINER, className);

    // return (
    //   <div className="site">
    //       <div className="fixed-footer">
    //           <div className="flex-parent">
    //               <div className="flex-buttons">
    //                   <div className="button">Update</div>
    //                   <div className="button">Cancel</div>
    //               </div>
    //           </div>
    //       </div>
    //       <div className="page-scroll">bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla blabla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla blabla bla bla</div>
    //   </div>      
    // )

    return (
      <div className={classes}>
        <div
          className={myClasses.ALERTS_CONTENT_DETAILS_FOOTER_INNER_CONTAINER}
          >
          <MPDButton
            className={myClasses.ALERTS_CONTENT_DETAILS_CANCEL}
            text="CANCEL"
            onClick={this.onCancelClick}
          />
          <MPDButton
            className={myClasses.ALERTS_CONTENT_DETAILS_UPDATE}
            text="UPDATE"
            onClick={this.onUpdateClick}
          />
        </div>
        <Alert
          isOpen={
            updateAlertState === "update" || updateAlertState === "cancel"
          }
          className="alert-update-container"
          canOutsideClickCancel={true}
          onClose={this.onCloseClick}
        >
          <div className="inner-container">
            <div className="header">
              <Text className="title">{warningContent.header}</Text>
              <MPDButton
                name="update-alert--exit"
                onClick={this.onCloseClick}
              />
            </div>
            <div className="body">
              <hr />
              <div className="sub-header">
                <Text className="type">{warningContent.type}</Text>
                <Text className="title">{warningContent.title}</Text>
                <textarea
                  rows={3}
                  autoCapitalize="none"
                  autoCorrect="none"
                  placeholder="add description..."
                  tabIndex={1}
                />
                <div className="files-container">
                  {multiMedia.files.map(
                    (element: any, index: number) =>
                      element !== null && element.id.includes("image") ? (
                        <div className="images-placeholder-container" key={index}>
                          <div className="placeholder-image">
                            <img src={element.src} />
                          </div>
                          <div className="exit">
                            <MPDButton
                              name="compose-images-exit"
                              onClick={e => this.onRemoveFile(e, element.name)}
                            />
                          </div>
                        </div>
                      ) : (
                        element !== null && (
                          <div className="files-placeholder-container" key={index}>
                            <MPDIcon
                              name="fil-audio"
                              className={classNames(
                                "left-icon",
                                element.id === "audio" && Classes.ACTIVE
                              )}
                            />
                            <MPDIcon
                              name="fil-movie"
                              className={classNames(
                                "left-icon",
                                element.id === "video" && Classes.ACTIVE
                              )}
                            />
                            <MPDIcon
                              name="fil-attach"
                              className={classNames(
                                "left-icon",
                                element.id === "document" && Classes.ACTIVE
                              )}
                            />
                            <Text className="name"> {element.name} </Text>
                            <Text className="size"> {element.size} MB </Text>
                            <MPDButton
                              className="exit"
                              name="compose-files-exit"
                              onClick={e => this.onRemoveFile(e, element.name)}
                            />
                          </div>
                        )
                      )
                  )}
                </div>
                <MultiMediaActive
                  className={classNames(
                    multiMedia.state !== "init" && Classes.ACTIVE
                  )}
                  multiMedia={multiMedia}
                  onMultiMediaOnDrop={this.onMultiMediaDrop}
                  onMultiMediaStateChange={e =>
                    this.onMultiMediaStateChange(e, "", "init")}
                />
              </div>
            </div>
            <div className="footer">
              <div className="add-media">
                <MPDButton
                  className={classNames(
                    updateAlertState !== "cancel" && Classes.ACTIVE
                  )}
                  name="compose-alert--add-photo"
                  selectName="photo-active"
                  itemState={
                    multiMedia.state === "image" ? (
                      States.selected
                    ) : (
                      States.default
                    )
                  }
                  onClick={e =>
                    this.onMultiMediaStateChange(e, "image/*", "image")}
                />
                <MPDButton
                  className={classNames(
                    updateAlertState !== "cancel" && Classes.ACTIVE
                  )}
                  name="compose-alert--add-video"
                  selectName="video-active"
                  itemState={
                    multiMedia.state === "video" ? (
                      States.selected
                    ) : (
                      States.default
                    )
                  }
                  onClick={e =>
                    this.onMultiMediaStateChange(e, "video/*", "video")}
                />
                <MPDButton
                  className={classNames(
                    updateAlertState !== "cancel" && Classes.ACTIVE
                  )}
                  name="compose-alert--add-document"
                  selectName="document-active"
                  itemState={
                    multiMedia.state === "document" ? (
                      States.selected
                    ) : (
                      States.default
                    )
                  }
                  onClick={e =>
                    this.onMultiMediaStateChange(
                      e,
                      ".doc, .docx,.ppt, .pptx,.txt,.pdf",
                      "document"
                    )}
                />
                <MPDButton
                  className={classNames(
                    Classes.ACTIVE,
                    multiMedia.state === "voice" && Classes.SELECT
                  )}
                  name="compose-alert--add-voice"
                  selectName="voice-active"
                  itemState={
                    multiMedia.state === "audio" ? (
                      States.selected
                    ) : (
                      States.default
                    )
                  }
                  onClick={e =>
                    this.onMultiMediaStateChange(e, "audio/*", "audio")}
                />
              </div>
              <div className="send-update">
                <MPDButton text={warningContent.action} />
              </div>
            </div>
          </div>
        </Alert>
        <MPDHiddenScrollContainer yDirection={true}>
          {/* <div className={myClasses.ALERTS_CONTENT_INNER_CONTAINER}> */}
            <div className={myClasses.ALERTS_CONTENT_INFO_CONTAINER}>
              <div className={Classes.LEFT}>
                <div className={myClasses.ALERTS_CONTENT_FROSTED_CONTAINER}>
                  <Text
                    className={classNames(
                      myClasses.ALERTS_CONTENT_SUBTITLE,
                      Classes.severitiesClass(type)
                    )}
                  >
                    {type}
                  </Text>
                  <Text className={myClasses.ALERTS_CONTENT_TITLE}>
                    {title}
                  </Text>
                  <Text className={myClasses.ALERTS_CONTENT_DATE}>
                    {convertUTCToFormattedText(date)}
                  </Text>
                </div>
                <div className={myClasses.ALERTS_CONTENT_INFO_DESCRIPTION}>
                  <h6> Description </h6>
                  <p>{description}</p>
                </div>
                <div className={myClasses.ALERTS_CONTENT_INFO_INSTRUCTIONS}>
                  <h6> Instructions </h6>
                  <p>{instructions}</p>
                  <div className={myClasses.ALERTS_CONTENT_DETAILS_CONTAINER}>
                    <h6> Details </h6>
                    <div
                      className={
                        myClasses.ALERTS_CONTENT_DETAILS_OUTER_CONTAINER
                      }
                    >
                      <div className={myClasses.ALERTS_CONTENT_DETAILS_HEADERS}>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          sent on
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          expires
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          severity
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          urgency
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          certainty
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          sent by
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          area
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          agency
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          alert type
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          status
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          another item
                        </Text>
                        <Text
                          className={myClasses.ALERTS_CONTENT_DETAILS_HEADER}
                        >
                          big item
                        </Text>
                      </div>
                      <div
                        className={
                          myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTIONS
                        }
                      >
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {sentOn}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {expires}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {severity}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {urgency}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {certainty}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {sentBy}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {area}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {agency}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {alertType}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {status}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {anotherItem}
                        </Text>
                        <Text
                          className={
                            myClasses.ALERTS_CONTENT_DETAILS_DESCRIPTION
                          }
                        >
                          {bigItem}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={Classes.RIGHT}>
                <div
                  className={myClasses.ALERTS_CONTENT_FROSTED_MOBILE_CONTAINER}
                >
                  <Text
                    className={classNames(
                      myClasses.ALERTS_CONTENT_SUBTITLE,
                      Classes.severitiesClass(type)
                    )}
                  >
                    {type}
                  </Text>
                  <Text className={myClasses.ALERTS_CONTENT_TITLE}>
                    {title}
                  </Text>
                  <Text className={myClasses.ALERTS_CONTENT_DATE}>
                    {convertUTCToFormattedText(date)}
                  </Text>
                </div>
                <Timer
                  className={classNames(
                    myClasses.ALERTS_CONTENT_EXPIRES,
                    Classes.severitiesClass(type)
                  )}
                  timerMessageExpires={
                    listItem.type === "scheduled" ? "Scheduled" : "Sent"
                  }
                  startTime="1532555097"
                  endTime="1532807390"
                  timerMessage="Expires In"
                />
                <div className={myClasses.ALERTS_CONTENT_ANALYTICS_CONTAINER}>
                  <div
                    className={classNames(
                      myClasses.ALERTS_CONTENT_ANALYTICS,
                      Classes.severitiesClass(type)
                    )}
                  >
                    <div className={myClasses.ALERTS_CONTENT_ANALYTICS_ITEM}>
                      <PieChart width={60} height={60}>
                        <Pie
                          activeShape={this.renderActiveShape}
                          activeIndex={0}
                          data={dataReach}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={30}
                          innerRadius={25}
                          fill="#b01429"
                        />
                      </PieChart>
                      <Text> Total Reach </Text>
                    </div>
                    <div className={myClasses.ALERTS_CONTENT_ANALYTICS_ITEM}>
                      <PieChart width={60} height={60}>
                        <Pie
                          activeShape={this.renderActiveShape}
                          activeIndex={0}
                          data={dataViews}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={30}
                          innerRadius={25}
                          fill="#b01429"
                        />
                      </PieChart>
                      <Text> Views </Text>
                    </div>
                    <div className={myClasses.ALERTS_CONTENT_ANALYTICS_ITEM}>
                      <PieChart width={60} height={60}>
                        <Pie
                          activeShape={this.renderActiveShape}
                          activeIndex={0}
                          data={dataReplies}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={30}
                          innerRadius={25}
                          fill="#b01429"
                        />
                      </PieChart>
                      <Text> Replies </Text>
                    </div>
                  </div>
                </div>
                <div className={myClasses.ALERTS_CONTENT_DETAILS_IMAGE}>
                  {imagesLoading && <div className="image-filler" />}
                  <img
                    src={imageSrc}
                    onLoad={e => this.setState({ imagesLoading: false })}
                  />
                </div>
                
              </div>
            </div>
          {/* </div> */}
        </MPDHiddenScrollContainer>
        <div className={myClasses.ALERTS_CONTENT_MAP_CONTAINER}>
          {showMap &&
          <GeoMap
            currentShape={currentShape}
            style={{ height: `100%` }}
            center={mapCenter}
            hideControls={true}
            zoom={14}
          />
          }
        </div>
      </div>
    );
  }

  private updateToolBar(title: string) {
    // const { listItem } = this.props;
    const topBarProps = {
      leftElement: (
        <ToggleButtons
          label={title}
          onToggle={this.onToggleRightPanel}
          onClose={this.onCloseRightPanel}
        />
      ),
      rightElement: (
        <DuoButtons
          firstButtonClick={this.onCancelClick}
          secondButtonClick={this.onUpdateClick}
          firstButtonText="Cancel"
          secondButtonText="Update Alert"
        />
      )
    };
    this.props.onUpdateToolBar(topBarProps);
  }

  

  private onRemoveFile(event: any, name: string) {
    this.props.removeFile(name);
  }

  private onMultiMediaDrop(files: any, id: string) {
    this.props.onUploadMultiMedia(files, id);
  }

  private onMultiMediaStateChange(event: any, fileTypes: string, type: string) {
    this.props.onMultiMediaStateChange(type, fileTypes);
  }

  private renderActiveShape = (props: any) => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload
    } = props;

    return (
      <g>
        <text
          className={myClasses.ALERTS_CONTENT_ANALYTICS_NUMBER}
          x={cx}
          y={cy}
          dy={8}
          textAnchor="middle"
        >
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    );
  };

  private onToggleRightPanel(event?: React.MouseEvent<any>) {
    this.props.onToggleRightPanel();
  }

  private onCloseRightPanel() {
    const { history } = this.props.routeProps;
    this.props.onCloseRightPanel(history);
  }

  private onUpdateClick(event: any) {
    this.props.onToggleUpdateAlert("update");
  }

  private onCancelClick(event: any) {
    this.props.onToggleUpdateAlert("cancel");
  }

  private onCloseClick(event: any) {
    this.props.onToggleUpdateAlert("init");
  }
}

const mapStateToProps = (state: any) => {
  const { alerts, global } = state;
  const { isMobileSize } = global;
  const {
    composeActive,
    listItem,
    rightPanelExpanded,
    warningContent,
    updateAlertState,
    multiMedia
  } = alerts;

  return {
    composeActive,
    listItem,
    isMobileSize,
    rightPanelExpanded,
    updateAlertState,
    warningContent,
    multiMedia
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onToggleRightPanel: bindActionCreators(
      alertListActions.onToggleRightPanel,
      dispatch
    ),
    onCloseRightPanel: bindActionCreators(
      alertListActions.onCloseRightPanel,
      dispatch
    ),
    onMultiMediaStateChange: bindActionCreators(
      alertActions.onMultiMediaStateChange,
      dispatch
    ),
    onToggleUpdateAlert: bindActionCreators(
      alertActions.onToggleUpdateAlert,
      dispatch
    ),
    onUploadMultiMedia: bindActionCreators(
      alertActions.onUploadMultiMedia,
      dispatch
    ),
    removeFile: bindActionCreators(alertActions.onRemoveMultiMedia, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Description);


// WEBPACK FOOTER //
// ./src/controllers/alerts/description/description.tsx